module.exports = __webpack_public_path__ + "static/media/SEA-LAND.7066c21b.svg";